import { components as wxComponents } from '@vnxjs/plugin-platform-weapp/dist/runtime-utils'
import { mergeInternalComponents, mergeReconciler } from '@vnxjs/shared'

import { initNativeApi } from './apis'
import { components } from './components'

export const hostConfig = {
  initNativeApi
}

mergeReconciler(hostConfig)
mergeInternalComponents(wxComponents)
mergeInternalComponents(components)
